var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"ai-beta-note mt-2"},[_c('v-icon',{staticClass:"mr-1 ai-beta-note__icon",attrs:{"x-small":""}},[_vm._v("mdi-flask-outline")]),_vm._v(" "+_vm._s(_vm.$t('ai.beta_note'))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }